/* Product cards must show their FIRST image while browsing. The shared
   slideshow component re-derives its current slide from scroll position, so
   scrolling the page (and section re-renders after filtering) could leave a
   card showing its 2nd/3rd image. This pins every card gallery to slide 0
   until the visitor actually interacts with that specific gallery; swiping,
   arrows and hover-preview keep working untouched. */
(function () {
  'use strict';

  var TOUCHED = 'data-hz-touched';

  /* V19 FIX: the "already wired" guard used to be a DOM attribute
     (data-hz-pinned). morph.js strips attributes that are absent from the
     server HTML, so after every filter or pagination action the guard was gone
     and wire() attached another seven listeners to the same element -- stacking
     without limit during a filter session. A WeakSet lives outside the DOM, so
     morph cannot clear it, and entries are garbage collected with the node. */
  var wired = new WeakSet();

  function scrollers() {
    return document.querySelectorAll('.card-gallery slideshow-slides');
  }

  function isTouched(el) {
    return el.hasAttribute(TOUCHED);
  }

  function markTouched(el) {
    el.setAttribute(TOUCHED, '1');
  }

  function pin(el) {
    if (isTouched(el)) return;
    if (el.scrollLeft !== 0) el.scrollLeft = 0;
  }

  function wire(el) {
    if (wired.has(el)) return;
    wired.add(el);

    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (evt) {
      el.addEventListener(evt, function () { markTouched(el); }, { passive: true });
    });

    // Arrows and any programmatic select inside this gallery count as intent.
    var gallery = el.closest('.card-gallery');
    if (gallery) {
      gallery.addEventListener('click', function (e) {
        if (e.target.closest('slideshow-arrows, [ref="next"], [ref="previous"], button')) markTouched(el);
      }, { passive: true });
      gallery.addEventListener('pointerenter', function () { markTouched(el); }, { passive: true });
    }

    el.addEventListener('scroll', function () { pin(el); }, { passive: true });
    // V35 PERF: scrollLeft lezen dwingt een lay-out af. Pas na het volgende frame lezen,
    // als de browser de lay-out toch al berekend heeft, niet midden in het laden.
    requestAnimationFrame(function () { setTimeout(function () { pin(el); }, 0); });
  }

  function scan() {
    scrollers().forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Sections re-render on filtering/pagination: re-wire and re-pin fresh cards.
  // V35 PERF: alleen de hoofdinhoud en de cart-popup volgen, niet de hele pagina. De observer
  // op document.documentElement draaide ook bij elk script dat Shopify of apps in de head en
  // body zetten, en kostte op mobiel 210 tot 310 ms per pagina.
  var pending = false;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      scan();
    });
  });
  var observed = new WeakSet();
  function observeRoots() {
    var roots = [document.getElementById('MainContent')].concat(
      Array.prototype.slice.call(document.querySelectorAll('cart-drawer-component, .cart-drawer, product-recommendations'))
    );
    roots.forEach(function (root) {
      if (!root || observed.has(root)) return;
      observed.add(root);
      observer.observe(root, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeRoots);
  } else {
    observeRoots();
  }
  // De cart-popup en aanbevelingen kunnen later in de pagina komen.
  document.addEventListener('cart:update', function () { observeRoots(); scan(); });
  window.addEventListener('load', function () { observeRoots(); scan(); });

  document.addEventListener('shopify:section:load', scan);
})();
